import React from 'react';
import { useT } from 'src/i18n';

import './Team.scss';

export const Team = () => {
  const t = useT();

  return (
    <>
      <h1 className="heading heading_team">
        {t.about.heading}
      </h1>
      <div className="team-block">
        {t.about.parts.map((part, index) => (part.chip ? (
          <span
            key={`chip-${part.text}`}
            className={`chip chip_${part.color} chip_static`}
          >
            {part.text}
          </span>
        ) : (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`text-${index}`}>{part.text}</React.Fragment>
        )))}
      </div>
    </>
  );
};
